import React from 'react';
import ErrorImage from '../../Assets/Error.png';
import { useNavigate } from 'react-router-dom';

function Error() {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/');
    }

    return (
        <div className='max-w-screen h-screen flex items-center justify-center overflow-y-scroll'>
            <div className="w-[47%] h-fit flex flex-col items-center gap-6">
                <div className="w-full">
                    <img className='w-full h-auto select-none' src={ErrorImage} alt="" />
                </div>

                <div className="flex flex-col items-center gap-4 w-full">
                    <h1 className='font-semibold text-[32px] leading-10 text-[#121212] text-center select-none'>Uh-oh! Looks like you took a wrong turn!</h1>

                    <p className='font-semibold text-base text-[#666666] text-center select-none'>We can't find the page you're looking for. It might be out setting up a stylish display somewhere!</p>
                </div>

                <button onClick={handleButtonClick} className='px-3 py-[10px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText select-none'>Back to dashboard</button>
            </div>
        </div>
    );
}

export default Error;
